import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';
import Noty from 'noty';

import authService from "../../domain/services/AuthService";
import { SignInEmailErrorCodeEnum } from '../../domain/enums/SignInEmailErrorEnum';
import { setProcessingLoaderVisibility } from "../../../layout/store/actions";

const namespace = 'AUTH_BY_FACEBOOK';

export const facebookSignInRequest = createAction(`${namespace}/FACEBOOK_SIGN_IN_REQUEST`);
export const facebookSignInSuccess = createAction(`${namespace}/FACEBOOK_SIGN_IN_SUCCESS`);
export const facebookSignInFailed = createAction(`${namespace}/FACEBOOK_SIGN_IN_FAILED`);

export const resetFacebookErrors= createAction(`${namespace}/RESET_FACEBOOK_ERRORS`);

export function loginByFacebook() {
  return (dispatch, getState) => {

    dispatch(batchActions([
      facebookSignInRequest(),
      setProcessingLoaderVisibility(true)
    ]));

    authService.signInWithFacebook()
    // on success loader will hide in "onAuthStateChanged" callback
      .then((response) => {
        dispatch(facebookSignInSuccess())
      })
      .catch((error) => {
        if (error.code === SignInEmailErrorCodeEnum.EmailAlreadyInUse) {
          new Noty({
            type: 'error',
            text: error.message,
            layout: 'center',
            timeout: 3000
          });
        }
        dispatch(batchActions([
          facebookSignInFailed(error),
          setProcessingLoaderVisibility(false)
        ]));
      })
  };
}


// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-by-facebook/actions.ts